import { cx } from '@twind/core';
import { FeedbackSentiment } from 'app/hooks/fetch/useFeedbackAnalytics';
import { useTranslation } from 'react-i18next';

import ThumbsUpIcon from '../icons/ThumbsUpIcon';

export default function PositiveFeedbackButton({
  onClick,
  filled,
}: {
  onClick: (feedbackSentiment: FeedbackSentiment) => void;
  filled: boolean;
}) {
  const { t } = useTranslation();
  return (
    <button
      onClick={() => onClick(FeedbackSentiment.POSITIVE)}
      className="rounded-full"
      aria-label={t('feedback.yes_label')}
      data-testid="feedback-thumbs-up"
      aria-pressed={filled}
    >
      <ThumbsUpIcon
        className={cx('w-4 h-4')}
        filled={filled}
      />
    </button>
  );
}
